// 本地存储模块
// 获取
export const getItem=(name)=>{
    // 未经处理的请求数据
    let res = localStorage.getItem(name) 
    try {
        let getResult = JSON.parse(res)
        return getResult
    }catch(e) {
        console.log(e)
        return res
    }
  
}
// 存储
export const setItem = (key,value) => {
    if(key && value) {
        try {
            let JsonVal = JSON.stringify(value)
            localStorage.setItem(key,JsonVal)
        } catch(e) {
            console.error(e)
        }
    } else {
        console.log('key,value不能为空')
    }
}
// 删除
export const removeItem=name=>{
    localStorage.removeItem(name)
}


// 写入
export const set = (name, value, { maxAge, domain, path, secure } = {}) => {
 
    let cookieText = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
    if (typeof maxAge === 'nmber') {
        cookieText += `; max-age=${maxAge}`
    }
    if (domain) {
        cookieText += `; domain=${domain}`
    }
    if (path) {
        cookieText += `; path=${path}`
    }
    if (secure) {
        cookieText += `; secure`
    }
    document.cookie = cookieText
}
 
// 读取
export const get = name => {
    name = `${encodeURIComponent(name)}`;
    const cookies = document.cookie.split('; ');
    for (let item of cookies) {
        const [cookieName, cookieValue] = item.split('=');
        if (cookieName === name) {
            return decodeURIComponent(cookieValue)
        }
    }
    return undefined;
}
 
// 删除 
export const remove = (name, { domain, path } = {}) => {
    set(name, '', { domain, path, maxAge: -1 })
}